<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  function handleClickUp() {
    dispatch('clickUp');
  }

  function handleClickDown() {
    dispatch('clickDown');
  }
</script>

<div class="mobile-controls">
  <p class="text-small mobile-controls__text">
    Press arrows to move design mockups
  </p>
  <div class="mobile-controls__buttons">
    <div
      on:click={handleClickUp}
      class="mobile-controls__btn mobile-controls__btn-down"
    />
    <div
      on:click={handleClickDown}
      class="mobile-controls__btn mobile-controls__btn-up"
    />
  </div>
</div>

<style lang="scss">
  .mobile-controls {
    width: 100%;
    color: var(--royal-light);
    z-index: 50;
    position: absolute;
    bottom: -13rem;

    :global .section & {
      bottom: -11rem;
    }

    &__text {
      text-align: center;
    }

    &__buttons {
      display: flex;
      justify-content: center;
      gap: 2rem;
      margin-top: 1rem;
    }

    &__btn {
      width: 5rem;
      height: 5rem;
      cursor: pointer;

      &-up {
        background: {
          image: url(img/scroll-arrow-up.svg);
          size: contain;
          position: center;
          repeat: no-repeat;
        }
        // background-color: yellow;
      }

      &-down {
        background: {
          image: url(img/scroll-arrow-down.svg);
          size: contain;
          position: center;
          repeat: no-repeat;
        }
        // background-color: yellow;
      }
    }
  }

  .hero-loader {
    position: absolute;
    z-index: 10;
    inset: 0;

    background: rgb(var(--white));

    display: flex;
    align-items: center;
    justify-content: center;

    &__spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      margin: {
        top: -3.75rem;
        left: -3.75rem;
      }

      display: block;
      width: 7.5rem;
      height: 7.5rem;
      border-radius: 50%;

      mask-size: contain;

      background: conic-gradient(
        from 0.25turn at 50%,
        var(--aqua-2),
        rgb(var(--white))
      );

      animation: spin 3s infinite linear;
    }

    &__logo {
      width: 3rem;
    }
  }
</style>
